import { Badge } from '../ui';
import type { BadgeTone } from '../ui';
import { HOSTING_RUN_STATUS_LABEL, type HostingRunStatus } from '../../lib/hosting';

const RUN_TONE: Record<HostingRunStatus, BadgeTone> = {
  queued: 'neutral',
  running: 'info',
  passed: 'up',
  attention: 'warn',
  failed: 'down',
  cancelled: 'neutral',
};

/**
 * A checklist run's status pill; running pulses. A reviewed attention/failed
 * run reads healthy ("Reviewed") and keeps its original status in the tooltip.
 */
export default function RunStatusBadge({ status, reviewed, title }: { status: HostingRunStatus; reviewed?: boolean; title?: string }) {
  if (reviewed && (status === 'attention' || status === 'failed')) {
    return (
      <Badge tone="up" dot title={title ?? `Reviewed (was ${HOSTING_RUN_STATUS_LABEL[status]})`}>
        Reviewed
      </Badge>
    );
  }
  return (
    <Badge tone={RUN_TONE[status] ?? 'neutral'} dot pulse={status === 'running'} title={title}>
      {HOSTING_RUN_STATUS_LABEL[status] ?? status}
    </Badge>
  );
}
